import {capitalise} from "@/app/utils/StringUtils";

export default function(string) {
    return new Handlebars.SafeString(capitalise(string || ''));
}